<template>
  <div>
    <div class="outmain ba_f">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('jurisdiction.edit.shopNumLabel')" v-show="form.shopModel == '2'">
          <el-input v-model="form.shopNum" :placeholder="$t('jurisdiction.edit.shopNumPh')" v-show="!checked"></el-input>
          <el-checkbox v-model="checked" class="checkBox" @change="checkChange">{{ $t('jurisdiction.edit.unlimited') }}</el-checkbox>
        </el-form-item>
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('jurisdiction.edit.appPluginAuth') }}</span>
          </div>
        </div>
        <el-form-item :label="$t('jurisdiction.edit.appPlugin')">
          <el-checkbox-group v-model="form.use_str">
            <el-checkbox
              v-for="item in operation3"
              :label="item.name"
              :key="item.id"
              size="medium"
            >{{ item.use_name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('jurisdiction.edit.valuePluginAuth') }}</span>
          </div>
        </div>
        <el-form-item :label="$t('jurisdiction.edit.valuePlugin')">
          <el-checkbox-group v-model="form.plug_str">
            <el-checkbox
              v-for="item in operation2"
              :label="item.id"
              :key="item.id"
              size="medium"
            >{{ item.use_name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('jurisdiction.edit.otherPerm') }}</span>
          </div>
        </div>
        <el-form-item :label="$t('jurisdiction.edit.serviceQq')">
          <el-input v-model="form.qq" :placeholder="$t('jurisdiction.edit.serviceQqPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.edit.headerLogo')">
          <div class="uploadSource bor_de rel flex" v-if="form.icon">
            <label class="statusLabel curs" @mouseenter="enter(1)" @mouseleave="leave(1)">
              <i class="el-icon-check" ref="imgicon1"></i>
              <i class="el-icon-close" @click="deleteMultiImage(form.icon, 1)"></i>
            </label>
            <img :src="form.icon" @click="test(1)" class="wid" />
          </div>
          <div class="uploadSource flex-center curs" v-else @click="test(1)">
            <i class="el-icon-plus fon_40 color_d9"></i>
          </div>
          <div class="yb_margin">{{ $t('jurisdiction.edit.sizeTip') }}</div>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.edit.copyright')">
          <el-input v-model="form.content" :placeholder="$t('jurisdiction.edit.copyrightPh')" type="textarea"></el-input>
          <div class="yb_margin lh16">{{ $t('jurisdiction.edit.copyrightTip') }}</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
    <attachment-img ref="img1" type="img" @attachment="imgadd1"></attachment-img>
  </div>
</template>
<script>
import attachmentImg from "@/plugins/attachment-img";
import { getConfig, postConfig } from "@/api/set";
export default {
  created() {
    this.bus.$emit("loading", true);
    this.uniacid = this.$route.query.uniacid || "";
    this.init();
  },
  components: { attachmentImg },
  data() {
    return {
      form: {
        icon: "",
        name: "",
        channel_arr: [],
        plug_str: [],
        use_str: [],
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
        qq: "",
        makeName: "",
        shopModel: "1",
        shopNum: "50",
        content: "",
      },
      checked: false,
      uniacid: "",
      operation: [],
      operation2: [],
      operation3: [],
    };
  },
  methods: {
    async init() {
      const { data } = await getConfig({
        ident: "sysTopImage",
        uniacid: this.uniacid,
      });
      if (data.shopNum == 0 && data.shopModel == "2") {
        this.checked = true;
      }
      this.form2 = this.form;
      this.form = Object.assign(this.form2, data);
      if (this.form.shopModel == "1") {
        this.form.shopNum = "50";
      }
      this.operation = data.channel_list ? data.channel_list : [];
      this.operation2 = data.plug_list ? data.plug_list : [];
      this.operation3 = data.use_list ? data.use_list : [];
      this.bus.$emit("loading", false);
    },
    checkChange(val) {
      this.checked = val;
    },
    radioChange(val) {
      if (val == "1") {
        this.checked = false;
      }
    },
    enter(i = 0) {
      this.$refs["imgicon" + i].style.display = "none";
    },
    leave(i = 0) {
      this.$refs["imgicon" + i].style.display = "inline-block";
    },
    test(i = 0) {
      this.$refs["img" + i].dialogVisible = true;
    },
    imgadd1(url) {
      this.form.icon = url.str;
    },
    deleteMultiImage(item, index, type) {
      Array.prototype.remove = function (val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      if (type == "multigraph") {
        switch (index) {
          case 2:
            this.form2.environment.remove(item);
            break;
        }
      } else {
        switch (index) {
          case 1:
            this.form.icon = "";
            break;
        }
      }
    },
    submitForm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.ident = "sysTopImage";
          this.form.identName = this.$t('jurisdiction.edit.headerLogo');
          this.form.uniacid = this.uniacid;
          const selectOperation = this.operation.map((item) => item.id);
          const selectOperation2 = this.operation2.map((item) => item.id);
          this.form.channel_arr = this.getArrEqual(
            selectOperation,
            this.form.channel_arr
          );
          this.form.plug_str = this.getArrEqual(
            selectOperation2,
            this.form.plug_str
          );
          if (this.checked) {
            this.form.shopNum = 0;
          }
          const { msg } = await postConfig(this.form);
          this.$baseMessage(msg, "success");
          this.checked = false;
          this.form.shopNum = "50";
          this.init();
        } else {
          return false;
        }
      });
    },
    getArrEqual(arr1, arr2) {
      let newArr = [];
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr1[j] === arr2[i]) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
  },
};
</script>
<style>
.checkBox .el-checkbox__input {
  margin-left: 15px;
}
</style>
